// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import question css modules
import sentimentQuestionStyles from '../sentimentQuestionModuleStyles.css';

function SentimentQuestionListItem({ sentimentQuestion }) {
  return (
    <div>
      <Link to={`/admin/sentiment-questions/${sentimentQuestion._id}`}> {sentimentQuestion.orderWeight}. {sentimentQuestion.text}</Link>
    </div>
  )
}

SentimentQuestionListItem.propTypes = {
  sentimentQuestion: PropTypes.object.isRequired
}

export default SentimentQuestionListItem;



// WEBPACK FOOTER //
// modules/sentimentQuestion/components/SentimentQuestionListItem.js.jsx